import { BaseService } from "./BaseService";

export class PeerGroupService extends BaseService {
  getPeerGroups(profileId) {
    return super.invokeGet(this.APICONFIG.APIBASEURL + this.APICONFIG.GETPEERGROUPS + "?profileID=" + profileId);
  }
}
